import styled from 'styled-components';

export const ContainerCreditCardForm = styled.form`
  display: flex;
  flex: none;
  flex-direction: column;
  font-family: 'Libre Franklin', sans-serif;
  h2 {
    font-size: 5.866vw;
    font-weight: 700;
    margin: 0 0 4.266vw 0;
  }
`;

export const TitlePayment = styled.p`
  font-size: 5.866vw;
  font-weight: 700;
  margin: 5.066vw 0 1.6vw 0;
`;

export const ButtonPayment = styled.div`
  display: flex;
  flex: none;
  font-family: 'Libre Franklin', sans-serif;
  align-items: center;
  background-color: #000000;
  color: #ffffff;
  border-radius: 2.666vw;
  height: 13.333vw;
  width: 89.333vw;
  margin: 0 0 6.666vw 0;
  p {
    font-size: 4.266vw !important;
    font-weight: 400 !important;
    width: 40.533vw;
    margin-left: 1.84vw !important;
    color: #ffffff;
    background-color: transparent;
  }
  span {
    font-size: 3.466vw;
    font-weight: 400;
    margin: 0 0 0 16.266vw;
    color: #ffffff;
    background-color: transparent;
  }
`;

export const BackButton = styled.button`
  border: none;
  background-color: transparent;
  color: white;
  font-size: 4.466vw;
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 400;
  margin-left: 20vw;
`;

export const CreditCardIcon = styled.img`
  width: 5.4vw;
  height: 4.2vw;
  margin-left: 4.24vw;
`;

export const LoadingGif = styled.img`
  background-color: transparent;
  width: 13.333vw;
  height: 13.333vw;
`;

export const SideBySide = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  align-items: flex-start;
  justify-content: space-between;
  background-color: transparent;
`;

export const ButtonContinue = styled.button`
  font-family: 'Outfit', sans-serif;
  font-size: 4.266vw;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #ffffff;
  width: 89.333vw;
  height: 13.333vw;
  border: 1px solid #000000;
  border-radius: 2.666vw;
  margin-top: 3vw;
  background-color: #000000;
  cursor: pointer;
  flex: none;

  &:disabled {
    cursor: not-allowed;
    background-color: #efefef;
    border: none;
  }
`;

export const LabelInstallment = styled.label`
  display: block;
  margin-bottom: 1.6vw;
  box-sizing: border-box;
  padding-left: 3.6vw;
  font-weight: 400;
  font-size: 3.3vw;
  font-family: 'Libre Franklin', sans-serif;
`;

export const ContainerSelect = styled.div`
  position: relative;
  margin-bottom: 3vw;
`;

export const SelectInstallments = styled.select`
  width: 89.333vw;
  height: 13.333vw;
  border-radius: 1.342vh;
  border: 1px solid #000000;
  padding-left: 3.733vw;
  font-size: 0.938rem;
  font-family: 'Libre Franklin', sans-serif;
  -webkit-appearance: none;
  z-index: 1;
  -moz-appearance: none;
  outline: none;
  background-color: transparent;
  color: #000000;

  &:focus {
    border: 2px solid black;
    color: black;
  }
  option {
    color: #000000;
  }
`;

export const IconArrowDown = styled.img`
  background-color: transparent;
  width: 4vw;
  height: 4vw;
  position: absolute;
  right: 4vw;
  top: 10vw;
  flex: none;
`;
